import styled from 'styled-components'
import { NEUTRAL_100, BLACK } from '../../styles/colors'
import { INTER } from '../../styles/fonts';

export const Container = (styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 12px;
  border: 1px solid ${NEUTRAL_100};
  overflow: hidden;
  position: relative;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

interface HeaderProps {
  $backgroundColor: string;
}

export const Header = (styled.div<HeaderProps>`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${NEUTRAL_100};
  padding: 16px 12px;
  gap: 8px;
  background-color: ${props => props.$backgroundColor};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const HeaderText = (styled.span`
  font-family: ${INTER.regular};
  color: ${BLACK};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Body = (styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const BodyTitle = (styled.span`
  color: ${BLACK};
  font-family: ${INTER.medium};
  margin-bottom: 4px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const CoverContainer = (styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Footer = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 12px;
  background: linear-gradient(80deg, #C9ECFF88 1%, #82ADFF88 33%, #7B69FF88 62%, #9B1BFF88 95%);
  cursor: pointer;
  z-index: 2;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const FooterContent = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${BLACK};
  gap: 12px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const BenefitsContainer = (styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
